import {createApi} from '@reduxjs/toolkit/query/react';
import {
  BeneficiaryList,
  BeneficiaryListRequest,
  CreateBeneficiariesFromFile,
  CreateOrUpdateBeneficiary,
  DeleteBeneficiariesRequest,
  DeleteBeneficiaryRequest,
  ShareBeneficiariesRequest,
  SharedBeneficiaries
} from '../@types/BeneficiaryTypes';
import {axiosBaseQuery} from './api-utils';

const URL_API = '/business_webpaymentpro/rest/beneficiary';

export const beneficiaryApi = createApi({
  reducerPath: 'beneficiaryApi',
  baseQuery: axiosBaseQuery({
    baseUrl: URL_API
  }),
  tagTypes: ['Beneficiaries'],

  endpoints: builder => ({
    getBeneficiaries: builder.query<BeneficiaryList, BeneficiaryListRequest>({
      query: request => ({
        url: '/list',
        method: 'POST',
        data: request
      }),
      providesTags: (result, messages, request) => [
        {type: 'Beneficiaries', id: 'PARTIAL-LIST'},
        {type: 'Beneficiaries', id: request.page}
      ]
    }),
    createBeneficiary: builder.mutation<any, CreateOrUpdateBeneficiary>({
      query: formData => ({
        url: '/create',
        method: 'POST',
        data: formData
      }),
      invalidatesTags: ['Beneficiaries']
    }),
    createBeneficiariesFromFile: builder.mutation<any, CreateBeneficiariesFromFile>({
      query: formData => ({
        url: '/create-from-file',
        method: 'POST',
        formData: true,
        data: formData
      }),
      invalidatesTags: ['Beneficiaries']
    }),
    updateBeneficiary: builder.mutation<any, CreateOrUpdateBeneficiary>({
      query: formData => ({
        url: '/update',
        method: 'POST',
        data: formData
      }),
      invalidatesTags: ['Beneficiaries']
    }),
    deleteBeneficiary: builder.mutation<void, DeleteBeneficiaryRequest>({
      query: request => ({
        url: '/delete',
        method: 'POST',
        data: request
      }),
      invalidatesTags: (result, error, request) => [
        {type: 'Beneficiaries'}
      ]
    }),
    deleteBeneficiaries: builder.mutation<void, DeleteBeneficiariesRequest>({
      query: request => ({
        url: '/delete/list',
        method: 'POST',
        data: request
      }),
      invalidatesTags: (result, error, request) => [
        {type: 'Beneficiaries'}
      ]
    }),
    shareBeneficiaries: builder.mutation<SharedBeneficiaries, ShareBeneficiariesRequest>({
      query: request => ({
        url: '/share-list',
        method: 'POST',
        data: request
      }),
      invalidatesTags: (result, error, request) => [
        {type: 'Beneficiaries'}
      ]
    })
  })
});

export const {
  useGetBeneficiariesQuery,
  useCreateBeneficiaryMutation,
  useCreateBeneficiariesFromFileMutation,
  useUpdateBeneficiaryMutation,
  useDeleteBeneficiaryMutation,
  useDeleteBeneficiariesMutation,
  useShareBeneficiariesMutation
} = beneficiaryApi;
